module.exports = __webpack_public_path__ + "static/media/Info_popup@3x.d2f645b9.png";